<template>
  <a-card title="权益设置" :bordered="false" :bodyStyle="{paddingTop:'10px'}"
          :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
    <a-form-model
      ref="ruleForm" :model="ruleForm" :rules="rules"
      :label-col="currentFormLayout2.labelCol"
      :wrapper-col="currentFormLayout2.wrapperCol">
      <a-form-model-item label="权益名称" prop="name">
        <a-input v-model="ruleForm.name" allow-clear style="max-width: 400px;" :maxLength="6"
                 placeholder="请输入"></a-input>
      </a-form-model-item>
      <a-form-model-item label="券码ID" prop="couponId">
        <a-input v-model="ruleForm.couponId" disabled allow-clear style="max-width: 315px;" :maxLength="20"
                 placeholder="请输入"></a-input>
        <a-button :disabled="isDisabled" style="margin-left: 20px;" @click="onClickCode">增加</a-button>
      </a-form-model-item>
      <a-form-model-item label='权益介绍' prop='descUrl'>
        <custom-upload-pro-images v-model='ruleForm.descUrl'
                                  :pro-id='proId' :multiple-selected='true'
                                  :showDelete='true'
                                  :isProduct='false'
                                  tips='建议图片长宽比为1:1，宽度670px，高度最大2000px'
                                  :showFlag='false'
                                  :draggableUpdate='true'>
        </custom-upload-pro-images>
      </a-form-model-item>
      <a-form-model-item label="售价" prop="sellPrice">
        <a-input v-model="ruleForm.sellPrice" allow-clear style="max-width: 400px;" :maxLength="20"
                 placeholder="请输入"></a-input>
      </a-form-model-item>
      <a-form-model-item label="购买链接" prop="buyLink">
        <a-input v-model="ruleForm.buyLink" allow-clear style="max-width: 400px;" :maxLength="250"
                 placeholder="请输入"></a-input>
      </a-form-model-item>
      <a-form-model-item label="状态" prop="state">
        <a-radio-group v-model='ruleForm.state'>
          <a-radio :value='1'>上架</a-radio>
          <a-radio :value='0'>下架</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
        <a-button @click='onSubmit' :loading='submitLoading' type='primary'>保存设置</a-button>
        <a-button style="margin-left: 20px;" @click="backEvent">返回</a-button>
      </a-form-model-item>
    </a-form-model>

    <selected-product-dialog
      :show="showSelectedDialog"
      title='选择券码'
      ref="pageList"
      :itemNames="['search_proName']"
      :query-params="selectedQueryParams"
      :requestPromise="loadPromise"
      @close="showSelectedDialog=false"
      :columns="getColumns()"
    >
      <a-form-item label="券码名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.couponName"
                 style="width: 170px"
                 placeholder="请输入名称"
        ></a-input>
      </a-form-item>
      <span slot="number" slot-scope="rowItem">
        {{ rowItem.record.usedNum }}/{{ rowItem.record.stockNum }}
      </span>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedResult(rowItem.record)">确认</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'NewHotelMember',
  mixins: [ruleFormMixins],
  components: { CustomUploadProImages, SelectedProductDialog },
  data() {
    return {
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      id: this.$route.query.id,
      proId: 0,
      isDisabled: false,
      ruleForm: {
        name: '',
        couponId: '',
        descUrl: [],
        sellPrice: '',
        buyLink: '',
        state: 0,
        id: null
      },
      rules: {
        name: [{ required: true, message: '请输入权益名称', trigger: 'blur' }],
        couponId: [{ required: true, message: '请输入券码ID', trigger: 'blur' }],
        descUrl: [{ required: true, message: '请上传权益介绍', trigger: ['blur', 'change'] }],
        sellPrice: [{
          pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/,
          message: '请输入正确的金额',
          trigger: 'blur'
        }],
        buyLink: [{ required: true, message: '请输入购买链接', trigger: 'blur' }],
        state: [{ required: true, message: '请选择权益状态', trigger: 'change' }]
      },
      loading: false,
      submitLoading: false,
      showSelectedDialog: false,
      selectedQueryParams: {
        type: 'JHM',
        couponName: ''// 优惠券名称
      },
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      loadPromise: params => this.getListPromise(params)
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'HotelMemberList', title: '权益列表' },
      { name: 'HotelMemberInfo', title: '基础信息' }
    ])
    this.getDetails()
  },
  watch: {
    'ruleForm.descUrl': function(newVal, oldVal) {
      this.getLogUtils().logWithTag('descUrl', newVal)
    }
  },
  methods: {
    onClickCode() {
      this.showSelectedDialog = true
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getCouponService().post('couponSetInfo/selectCouponSetInfoList', params)
    },
    onSelectedResult(record) {
      this.ruleForm.couponId = record.id
      this.showSelectedDialog = false
    },
    getDetails() {
      if (this.id != 0) {
        this.getHttpServices().getCouponService().get('rights/getRightsInfo?id=' + this.id).then(res => {
          if (res && res.id) {
            this.ruleForm = res
            this.ruleForm.descUrl = res.descUrl ? res.descUrl.split(',') : []
            this.isDisabled = res.editCouponId ? false : true
          } else {
            this.resetForm()
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.resetForm()
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      params.descUrl = params.descUrl.join(',')
      this.getHttpServices().getCouponService().post('rights/editRightsInfo', params)
        .then(res => {
          const textStr = this.id == 0 ? '新建' : '编辑'
          this.$message.success(textStr + '权益设置成功')
          setTimeout(() => {
            this.backEvent()
          }, 500)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.submitLoading = false)
    },
    resetForm() {
      this.ruleForm = {
        name: '',
        couponId: '',
        descUrl: [],
        sellPrice: '',
        buyLink: '',
        state: 0,
        id: null
      }
    },
    getColumns() {
      return [
        {
          title: '券码ID',
          dataIndex: 'id'
        },
        {
          title: '券码名称',
          dataIndex: 'name',
          width: '25%'
        },
        {
          title: '券码类型',
          dataIndex: 'typeStr'
        },
        {
          title: '使用方式',
          dataIndex: 'useWayStr'
        },
        {
          title: '数量',
          dataIndex: 'number',
          scopedSlots: { customRender: 'number' }
        },
        {
          title: '状态',
          dataIndex: 'couponStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>